import { render, staticRenderFns } from "./FilesList.vue?vue&type=template&id=a5a003c4&scoped=true"
import script from "./FilesList.ts?vue&type=script&lang=ts&external"
export * from "./FilesList.ts?vue&type=script&lang=ts&external"
import style0 from "./FilesList.vue?vue&type=style&index=0&id=a5a003c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a003c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5a003c4')) {
      api.createRecord('a5a003c4', component.options)
    } else {
      api.reload('a5a003c4', component.options)
    }
    module.hot.accept("./FilesList.vue?vue&type=template&id=a5a003c4&scoped=true", function () {
      api.rerender('a5a003c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UnprocessedFiles/components/FilesList/FilesList.vue"
export default component.exports